import React from 'react';
import styled from 'styled-components';

const PolicyContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 80px 20px;
  min-height: 70vh;
`;

const Title = styled.h1`
  text-align: center;
  color: #333;
  margin-bottom: 20px;
  font-size: 2.5rem;
  font-weight: 700;
`;

const Subtitle = styled.p`
  text-align: center;
  color: #666;
  margin-bottom: 60px;
  font-size: 1.2rem;
  max-width: 800px;
  margin: 0 auto 60px;
`;

const Section = styled.div`
  margin-bottom: 50px;
  background: #f8f9fa;
  padding: 40px;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
`;

const SectionTitle = styled.h2`
  color: #333;
  margin-bottom: 25px;
  font-size: 1.8rem;
  font-weight: 600;
`;

const SectionContent = styled.div`
  color: #555;
  line-height: 1.8;
  font-size: 1.1rem;
  
  p {
    margin-bottom: 15px;
  }
  
  ul, ol {
    margin: 15px 0;
    padding-left: 30px;
    
    li {
      margin-bottom: 10px;
    }
  }
`;

const DefinitionsList = styled.div`
  margin-top: 20px;
`;

const DefinitionItem = styled.div`
  margin-bottom: 20px;
  padding: 20px;
  background: white;
  border-radius: 10px;
  border-left: 4px solid #4CAF50;
`;

const DefinitionTerm = styled.strong`
  color: #333;
  font-weight: 600;
  display: block;
  margin-bottom: 8px;
`;

const DefinitionDesc = styled.p`
  color: #666;
  margin: 0;
  line-height: 1.6;
`;

const ContactInfo = styled.div`
  background: #f8f9fa;
  padding: 30px;
  border-radius: 15px;
  text-align: center;
  margin-top: 40px;
`;

const ContactTitle = styled.h3`
  color: #333;
  margin-bottom: 20px;
  font-size: 1.4rem;
`;

const ContactItem = styled.div`
  margin-bottom: 15px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const ContactLabel = styled.span`
  color: #555;
  margin-right: 10px;
`;

const ContactValue = styled.span`
  color: #4CAF50;
  font-weight: 600;
`;

const PrivacyPolicy = () => {
  return (
    <PolicyContainer>
      <Title>Политика конфиденциальности</Title>
      <Subtitle>
        Настоящая Политика конфиденциальности определяет порядок обработки и защиты персональных данных пользователей сайта foodstar.pro
      </Subtitle>

      <Section>
        <SectionTitle>1. Основные понятия</SectionTitle>
        <SectionContent>
          <p>
            В настоящей Политике конфиденциальности следующие слова и выражения имеют указанные значения:
          </p>
          <DefinitionsList>
            <DefinitionItem>
              <DefinitionTerm>1.1. Сайт</DefinitionTerm>
              <DefinitionDesc>
                Сайт, расположенный в сети Интернет по адресу https://foodstar.pro
              </DefinitionDesc>
            </DefinitionItem>
            <DefinitionItem>
              <DefinitionTerm>1.2. Администрация Сайта</DefinitionTerm>
              <DefinitionDesc>
                Общество с ограниченной ответственностью «Лагом Лайф», расположенное по адресу: 446301, Самарская область, г. Отрадный, Спортивная ул., д. 7, ОГРН 1246300002409, ИНН 6318073403, КПП 637201001.
              </DefinitionDesc>
            </DefinitionItem>
            <DefinitionItem>
              <DefinitionTerm>1.3. Пользователь</DefinitionTerm>
              <DefinitionDesc>
                Пользователь Сайта, зарегистрированный в установленном порядке и использующий Сайт.
              </DefinitionDesc>
            </DefinitionItem>
            <DefinitionItem>
              <DefinitionTerm>1.4. Персональные данные</DefinitionTerm>
              <DefinitionDesc>
                Любая информация, относящаяся к прямо или косвенно определенному или определяемому физическому лицу (субъекту персональных данных).
              </DefinitionDesc>
            </DefinitionItem>
            <DefinitionItem>
              <DefinitionTerm>1.5. Политика</DefinitionTerm>
              <DefinitionDesc>
                Настоящая Политика конфиденциальности.
              </DefinitionDesc>
            </DefinitionItem>
          </DefinitionsList>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>2. Общие положения</SectionTitle>
        <SectionContent>
          <p>
            2.1. Настоящая Политика является официальным документом Администрации Сайта и определяет порядок обработки и защиты информации о физических лицах, использующих Сайт.
          </p>
          <p>
            2.2. Целью настоящей Политики является обеспечение надлежащей защиты информации о Пользователях, в том числе их персональных данных, от несанкционированного доступа и разглашения.
          </p>
          <p>
            2.3. Отношения, связанные со сбором, хранением, распространением и защитой информации о Пользователях, регулируются настоящей Политикой, иными официальными документами Администрации Сайта и действующим российским законодательством.
          </p>
          <p>
            2.4. Действующая редакция Политики является публичным документом, разработана Администрацией Сайта и доступна любому пользователю сети Интернет при переходе по ссылке https://foodstar.pro/privacy_policy.
          </p>
          <p>
            2.5. Администрация Сайта вправе вносить изменения в настоящую Политику. При внесении изменений в актуальной редакции указывается дата последнего обновления. Новая редакция Политики вступает в силу с момента ее размещения, если иное не предусмотрено новой редакцией Политики.
          </p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>3. Цели сбора персональных данных</SectionTitle>
        <SectionContent>
          <p>
            3.1. Администрация Сайта собирает и хранит только те персональные данные, которые необходимы для предоставления услуг и исполнения соглашений и договоров с Пользователем, за исключением случаев, когда законодательством предусмотрено обязательное хранение персональной информации в течение определенного законом срока.
          </p>
          <p>
            3.2. Персональные данные Пользователя Администрация Сайта обрабатывает в следующих целях:
          </p>
          <ul>
            <li>Идентификация стороны в рамках соглашений и договоров с Администрацией Сайта;</li>
            <li>Предоставление Пользователю услуг, включая обработку заказов и доставку товаров;</li>
            <li>Связь с Пользователем, в том числе направление уведомлений, запросов и информации, касающихся использования Сайта, оказания услуг, а также обработка запросов и заявок от Пользователя;</li>
            <li>Улучшение качества работы Сайта, удобства его использования, разработка новых услуг;</li>
            <li>Проведение статистических и иных исследований на основе обезличенных данных.</li>
          </ul>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>4. Условия обработки персональных данных</SectionTitle>
        <SectionContent>
          <p>
            4.1. Обработка персональных данных Пользователя осуществляется без ограничения срока, любым законным способом, в том числе в информационных системах персональных данных с использованием средств автоматизации или без использования таких средств.
          </p>
          <p>
            4.2. Администрация Сайта принимает необходимые правовые, организационные и технические меры для защиты персональных данных Пользователя от неправомерного доступа, уничтожения, изменения, блокирования, копирования, предоставления, распространения, а также от иных неправомерных действий третьих лиц.
          </p>
          <p>
            4.3. При обработке персональных данных Пользователя Администрация Сайта руководствуется Федеральным законом РФ «О персональных данных» от 27.07.2006 № 152-ФЗ.
          </p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>5. Состав персональных данных</SectionTitle>
        <SectionContent>
          <p>
            5.1. Администрация Сайта обрабатывает следующие персональные данные Пользователя:
          </p>
          <ul>
            <li>Фамилия, имя, отчество;</li>
            <li>Номер телефона;</li>
            <li>Адрес электронной почты;</li>
            <li>Почтовый адрес (для доставки товаров);</li>
            <li>Данные для идентификации (логин, пароль);</li>
            <li>Данные об устройстве и браузере Пользователя (IP-адрес, тип устройства, версия браузера);</li>
            <li>Информация о заказах и покупках;</li>
            <li>Иная информация, предоставленная Пользователем при использовании Сайта.</li>
          </ul>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>6. Передача персональных данных</SectionTitle>
        <SectionContent>
          <p>
            6.1. Персональные данные Пользователей не передаются каким-либо третьим лицам, за исключением случаев, прямо предусмотренных настоящей Политикой.
          </p>
          <p>
            6.2. Предоставление персональных данных Пользователей по запросу государственных органов (органов местного самоуправления) осуществляется в порядке, предусмотренном законодательством.
          </p>
          <p>
            6.3. Администрация Сайта вправе передавать персональные данные третьим лицам в следующих случаях:
          </p>
          <ul>
            <li>Пользователь выразил свое согласие на такие действия;</li>
            <li>Передача необходима для использования Пользователем определенного сервиса либо для исполнения определенного соглашения или договора с Пользователем;</li>
            <li>Передача предусмотрена российским или иным применимым законодательством в рамках установленной законодательством процедуры;</li>
            <li>В целях обеспечения возможности защиты прав и законных интересов Администрации Сайта или третьих лиц в случаях, когда Пользователь нарушает Пользовательское соглашение Сайта.</li>
          </ul>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>7. Права и обязанности Пользователей</SectionTitle>
        <SectionContent>
          <p>
            7.1. Пользователи вправе:
          </p>
          <ul>
            <li>Осуществлять свободный бесплатный доступ к информации о себе посредством использования Сайта;</li>
            <li>На основании запроса получать от Администрации Сайта информацию, касающуюся обработки его персональных данных;</li>
            <li>Требовать уточнения персональных данных, их блокирования или уничтожения в случае, если персональные данные являются неполными, устаревшими, неточными, незаконно полученными или не являются необходимыми для заявленной цели обработки;</li>
            <li>Отозвать согласие на обработку персональных данных;</li>
            <li>Обжаловать действия или бездействие Администрации Сайта в уполномоченный орган по защите прав субъектов персональных данных или в судебном порядке.</li>
          </ul>
          <p>
            7.2. Пользователи обязаны предоставлять достоверную информацию о себе при регистрации и использовании Сайта.
          </p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>8. Меры по защите информации о Пользователях</SectionTitle>
        <SectionContent>
          <p>
            Администрация Сайта принимает технические и организационно-правовые меры в целях обеспечения защиты персональных данных Пользователя от неправомерного или случайного доступа к ним, уничтожения, изменения, блокирования, копирования, распространения, а также от иных неправомерных действий.
          </p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>9. Ограничение действия Политики</SectionTitle>
        <SectionContent>
          <p>
            Действие настоящей Политики не распространяется на действия и интернет-ресурсы третьих лиц. Администрация Сайта не несет ответственности за действия третьих лиц, получивших в результате использования Сайта доступ к информации о Пользователе, которая, в силу природы Сайта, доступна любому пользователю сети Интернет.
          </p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>10. Обращения Пользователей</SectionTitle>
        <SectionContent>
          <p>
            10.1. Пользователи вправе направлять Администрации Сайта свои запросы, в том числе запросы относительно использования их персональных данных, в письменной форме по адресу: 446301, Самарская область, г. Отрадный, Спортивная ул., д. 7, или в форме электронного документа, подписанного квалифицированной электронной подписью в соответствии с законодательством Российской Федерации, по адресу электронной почты: lagomlife@mail.ru.
          </p>
          <p>
            10.2. Запрос, направляемый Пользователем, должен содержать следующую информацию:
          </p>
          <ul>
            <li>Номер основного документа, удостоверяющего личность Пользователя или его представителя;</li>
            <li>Сведения о дате выдачи указанного документа и выдавшем его органе;</li>
            <li>Сведения, подтверждающие участие Пользователя в отношениях с Администрацией Сайта;</li>
            <li>Подпись Пользователя или его представителя.</li>
          </ul>
          <p>
            10.3. Администрация Сайта обязуется рассмотреть и направить ответ на поступивший запрос Пользователя в течение 30 дней с момента поступления обращения.
          </p>
          <p>
            10.4. Вся корреспонденция, полученная Администрацией Сайта от Пользователей (обращения в письменной или электронной форме), относится к информации ограниченного доступа и не разглашается без письменного согласия Пользователя.
          </p>
        </SectionContent>
      </Section>

      <ContactInfo>
        <ContactTitle>Контактная информация</ContactTitle>
        <ContactItem>
          <ContactLabel>Адрес:</ContactLabel>
          <ContactValue>446301, Самарская область, г. Отрадный, Спортивная ул., д. 7</ContactValue>
        </ContactItem>
        <ContactItem>
          <ContactLabel>ИНН:</ContactLabel>
          <ContactValue>6318073403</ContactValue>
        </ContactItem>
        <ContactItem>
          <ContactLabel>КПП:</ContactLabel>
          <ContactValue>637201001</ContactValue>
        </ContactItem>
        <ContactItem>
          <ContactLabel>ОГРН:</ContactLabel>
          <ContactValue>1246300002409</ContactValue>
        </ContactItem>
        <ContactItem>
          <ContactLabel>Email:</ContactLabel>
          <ContactValue>lagomlife@mail.ru</ContactValue>
        </ContactItem>
      </ContactInfo>
    </PolicyContainer>
  );
};

export default PrivacyPolicy;

